import { useContext } from 'react'
import { WorkspaceSlugContext } from '../contexts'

export function useWorkspaceSlug () {
  return useContext(WorkspaceSlugContext)
}
